define('home/views/ChannelCardExploreView',[
    'underscore',

    'core/config',

    'home/views/ChannelCardView',
    'home/templates/channelCardExplore',
], function (
    _,

    config,

    ChannelCardView,
    channelCardExploreTemplate
) {
    'use strict';

    /**
     * View is explore feed card that is stripped down
     * link version of the card.
     */

    var ChannelCardExploreView = ChannelCardView.extend({
        template: channelCardExploreTemplate,
        className: 'card-wrap card--channel -link',

        templateHelpers: function () {
            var templateHelpers = ChannelCardView.prototype.templateHelpers;

            return _.defaults({
                guestAvatar: config.urls.avatar.generic,
            }, _.isFunction(templateHelpers) ? templateHelpers.call(this) : templateHelpers);
        },
    });

    return ChannelCardExploreView;
});

